import React, { useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const TruckForm = ({ truck = {}, onCancelEdit, onSuccessfulSubmit }) => {
  const [formData, setFormData] = useState({
    unitNumber: truck.unitNumber || '',
    manufacturer: truck.manufacturer || '',
    style: truck.style || '',
    assignment: truck.assignment || '',
    unitStatus: truck.unitStatus || 'A', // Active by default
  });
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const isEdit = Boolean(truck?.id && truck?.type);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  async function authHeaders() {
    const { tokens } = await fetchAuthSession();
    const jwt = tokens?.idToken?.toString?.() ?? tokens?.accessToken?.toString?.();
    return jwt ? { Authorization: `Bearer ${jwt}` } : {};
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMsg('');

    const apiEndpoint = 'https://2af2e5kjj9.execute-api.us-east-1.amazonaws.com/prod/updatetruck';

    // Generate id/type for create; preserve for edit
    const nowIso = new Date().toISOString();
    const requestBody = {
      id: truck?.id ?? nowIso,                 // required by backend
      type: truck?.type ?? 200,                // units are type=200
      updatedAt: nowIso,                       // always update
      unitNumber: (formData.unitNumber || '').trim(),
      manufacturer: formData.manufacturer || '',
      style: formData.style || '',
      assignment: formData.assignment || '',
      unitStatus: formData.unitStatus || 'A',
    };

    try {
      const res = await fetch(apiEndpoint, {
        method: 'POST', // or 'PUT' if your API expects it; keeping POST per your code
        headers: {
          'Content-Type': 'application/json',
          ...(await authHeaders()),
        },
        body: JSON.stringify(requestBody),
      });

      const text = await res.text();
      let json; try { json = text ? JSON.parse(text) : null; } catch { json = null; }

      if (!res.ok || json?.success === false) {
        const msg = json?.message || `HTTP ${res.status}`;
        throw new Error(msg);
      }

      onSuccessfulSubmit?.();
      onCancelEdit?.();
    } catch (err) {
      console.error('Error submitting form:', err);
      setErrorMsg(err?.message || 'Error submitting form');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <h2>{isEdit ? 'Edit Truck' : 'Add Truck'}</h2>

      {errorMsg && (
        <p style={{ color: '#C80036', marginTop: 0 }}>{errorMsg}</p>
      )}

      <form onSubmit={handleSubmit} className="form-container">
        <div className="input-row">
          <div className="input-group">
            <label htmlFor="unitNumber">Unit Number:</label>
            <input
              type="text"
              id="unitNumber"
              name="unitNumber"
              value={formData.unitNumber}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="manufacturer">Manufacturer:</label>
            <input
              type="text"
              id="manufacturer"
              name="manufacturer"
              value={formData.manufacturer}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-group">
            <label htmlFor="style">Style:</label>
            <input
              type="text"
              id="style"
              name="style"
              value={formData.style}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-group">
            <label htmlFor="assignment">Assignment:</label>
            <input
              type="text"
              id="assignment"
              name="assignment"
              value={formData.assignment}
              onChange={handleInputChange}
            />
          </div>

          <div className="input-group">
            <label htmlFor="unitStatus">Unit Status:</label>
            <select
              id="unitStatus"
              name="unitStatus"
              value={formData.unitStatus}
              onChange={handleInputChange}
            >
              <option value="A">Active</option>
              <option value="I">Inactive</option>
            </select>
          </div>
        </div>

        <div className="button-container">
          <button type="submit" disabled={submitting}>
            {submitting ? 'Saving…' : 'Save'}
          </button>
          <button type="button" onClick={onCancelEdit} disabled={submitting}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default TruckForm;
